import React from 'react'
import 'antd/dist/antd.css';
import { RoutesApp } from './pages/Routes';
import './global.css';

function App() {
  return (<RoutesApp/>)
}

export default App
